import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "intercom-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.95004 11.9C7.61867 11.6515 7.14857 11.7187 6.90004 12.05C6.65152 12.3814 6.71867 12.8515 7.05004 13.1C9.98338 15.3 14.0167 15.3 16.95 13.1C17.2814 12.8515 17.3486 12.3814 17.1 12.05C16.8515 11.7187 16.3814 11.6515 16.05 11.9C13.65 13.7 10.35 13.7 7.95004 11.9Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 2.25C3.92893 2.25 2.25 3.92893 2.25 6V16C2.25 18.0711 3.92893 19.75 6 19.75H16.9428L19.8375 21.5592C20.2228 21.8 20.7085 21.8128 21.106 21.5925C21.5034 21.3722 21.75 20.9536 21.75 20.4992V6C21.75 3.92893 20.0711 2.25 18 2.25H6ZM3.75 6C3.75 4.75736 4.75736 3.75 6 3.75H18C19.2426 3.75 20.25 4.75736 20.25 6V20.0481L17.5554 18.364C17.4362 18.2895 17.2985 18.25 17.1579 18.25H6C4.75736 18.25 3.75 17.2426 3.75 16V6Z"
    }, null, -1)
  ])))
}
export default { render: render }